export const gmailEn = {
  UNLINK: 'Unlink',
  ACCOUNT_UNLINK_SUCCESSFULLY: 'Account unlinked successfully',
  ALLOW_TO_USE_YOUR_EMAIL_ADDRESS: 'Allow to use your email address',
  ALLOW: 'Allow',
  SEND_EMAIL_TEST: 'Send email test to this email address',
  LINKED_ACCOUNT: 'Linked account',
  SEND: 'Send',
  GMAIL_ERROR: 'There is a problem with your linked account, please unlink and try again',
  GMAIL_SCOPE_DIALOG_TITLE: 'Gmail permissions',
  GMAIL_SCOPE_DIALOG_BADGE: 'Required',
  GMAIL_SCOPE_DIALOG_BODY1: 'Please enable the permission below so we can send emails on your behalf.',
  GMAIL_SCOPE_DIALOG_BODY2:
    'Without it, notifications will be sent through our fallback email service to keep your communications running.',
  GMAIL_SCOPE_DIALOG_IMAGE_ALT: 'Example of the required Gmail permission',
  GMAIL_AUTHORIZATION_FAILED: 'Gmail authorization failed. Please try again.',
  GMAIL_AUTHORIZATION_SUCCESS: 'Access Token Stored Successfully!',
}

export const gmailEs: typeof gmailEn = {
  UNLINK: 'Desvincular',
  ACCOUNT_UNLINK_SUCCESSFULLY: 'Cuenta desvinculada correctamente',
  ALLOW_TO_USE_YOUR_EMAIL_ADDRESS: 'Permitir usar tu dirección de correo electrónico',
  ALLOW: 'Permitir',
  SEND_EMAIL_TEST: 'Enviar correo de prueba a esta dirección de correo',
  LINKED_ACCOUNT: 'Cuenta vinculada',
  SEND: 'Enviar',
  GMAIL_ERROR: 'Hay un problema con tu cuenta vinculada, desvincula e intenta de nuevo',
  GMAIL_SCOPE_DIALOG_TITLE: 'Permisos de Gmail',
  GMAIL_SCOPE_DIALOG_BADGE: 'Obligatorio',
  GMAIL_SCOPE_DIALOG_BODY1: 'Activa el permiso de abajo para que podamos enviar correos en tu nombre.',
  GMAIL_SCOPE_DIALOG_BODY2:
    'Sin eso, las notificaciones se enviarán mediante nuestro servicio de correo alterno para mantener tus comunicaciones activas.',
  GMAIL_SCOPE_DIALOG_IMAGE_ALT: 'Ejemplo del permiso requerido de Gmail',
  GMAIL_AUTHORIZATION_FAILED: 'La autorizacion de Gmail fallo. Intenta de nuevo.',
  GMAIL_AUTHORIZATION_SUCCESS: '¡Token de acceso almacenado correctamente!',
}
